<template>
  <Page :total="pageTotal" :current="pageParams.pageNum" :page-size="pageParams.pageSize" :page-size-opts="pageList" :transfer="true" show-elevator show-sizer show-total placement="top" @on-change="handlePage" @on-page-size-change='handlePageSize'></Page>
</template>
<script>
import { getDataList } from 'http/api/guild';
export default {
  name: 'IviewPage',
  data () {
    return {
      pageParams: {
        pageNum: 1,
        pageSize: 10
      },
      pageTotal: 0
    }
  },
  props: ['params', 'pageType', 'pageList', 'autoInit', 'defaultParams'],
  created () {
    if (this.defaultParams) {
      const { pageNum, pageSize } = this.defaultParams;
      this.pageParams = { pageNum, pageSize };
    }
    if (this.autoInit !== false) {
      this.getList()
    }
  },
  methods: {
    // 点击分页时触发
    handlePage (value) {
      if (value) this.pageParams.pageNum = value;
      this.getList()
    },
    // 切换每页显示条数时触发
    handlePageSize (value) {
      this.pageParams.pageSize = value;
      this.getList()
    },
    // 获取数据列表 init 是否从第一页开始
    getList (init) {
      if (init) {
        this.pageParams.pageNum = 1;
      }
      let self = this;
      let _list = [];
      // 兼容任务大厅加载9条的情况
      if (self.pageList) {
        self.pageParams = {
          pageNum: this.pageParams.pageNum,
          pageSize: this.pageParams.pageSize === 10 ? self.pageList[0] : this.pageParams.pageSize
        }
      }
      getDataList({pageType: self.pageType, params: Object.assign(self.pageParams, self.params)})
        .then(response => {
          if (response.data.list) {
            _list = response.data.list;
            self.pageTotal = response.data.total || response.data.count;
            self.$emit('give-list', _list);
          }
        })
        .catch(error => {
          console.log(error);
        })
    }
  }
}
</script>
